export default __webpack_public_path__ + "static/media/close.203a5c1a.svg";